<template>
    <modal
        ref="modal"
        :class="['custom-dialog', className]"
        @modalClosed="hide"
    >
        <template slot="icon">
            <icon :for="icon" />
        </template>
        <template
            v-if="title || withCloseButton"
            slot="header"
        >
            <div class="modal-heading">
                {{ title }}
            </div>
        </template>
        <div class="message body-large text-center w-full">
            {{ message }}
        </div>
        <div slot="footer">
            <div class="flex flex-col items-center juValistify-center">
                <div class="flex items-center w-full justify-center">
                    <template
                        v-for="button in buttons"
                    >
                        <component
                            :is="button.type"
                            v-if="button.type"
                            :key="button.label"
                            :class="[button.class]"
                            v-bind="button.props"
                            @click="resolveClick(button)"
                        >
                            {{ $t(`${button.label}`) }}
                        </component>
                        <button
                            v-else
                            :key="button.label"
                            :class="[button.class]"
                            @click="resolveClick(button)"
                        >
                            {{ $t(`${button.label}`) }}
                        </button>
                    </template>
                </div>
                <div
                    v-if="withCancel"
                    class="mt-xxs flex items-center"
                >
                    {{ $t(`common.or`) }}
                    <ui-text-button
                        class="ml-xxxs body-semibold text-purple"
                        @click="hide"
                    >
                        {{ $t(`common.cancel`) }}
                    </ui-text-button>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from './Modal.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';

export default {
    components: {
        Icon,
        Modal,
        UiTextButton,
    },
    props: {
        withCancel: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: 'New Message',
        },
        title: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'info',
        },
        buttons: {
            type: Array,
            default: () => [
                {
                    label: 'common.proceed',
                    value: true,
                    class: 'btn-primary',
                },
                {
                    label: 'cancel',
                    value: false,
                    class: 'btn-ghost',
                },
            ],
        },
        component: {
            type: String,
            default: null,
        },
        withCloseButton: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: 'close-c',
        },
    },
    data() {
        return {
            resolve: null,
            reject: null,
            styles: {
                error: {
                    class: 'error',
                    icon: 'icon-close-c',
                },
                warning: {
                    class: 'warning',
                    icon: 'icon-alert-c',
                },
                success: {
                    class: 'success',
                    icon: 'icon-check-c',
                },
                info: {
                    class: 'info',
                    icon: 'icon-eb-hired',
                },
                component: null,
            },
            backgroundStyle: {
                height: '100%',
            },
        };
    },
    computed: {
        style() {
            return this.styles[this.type] || this.styles.info;
        },
    },
    methods: {
        show() {
            this.promise = new Promise((resolve, reject) => {
                this.resolve = resolve || true;
                this.reject = reject || false;

                this.$refs.modal.show();
            });

            return this.promise;
        },
        resolveClick(button) {
            this.resolve(button.value);
            this.$refs.modal.hide();
        },
        hide() {
            this.$refs.modal.hide();
            this.reject(false);
        },
    },
};
</script>
<style lang="scss">
    @import 'common/scss/variables';
    @import "common/scss/palette";
    @import 'common/scss/shadows';
    @import "common/scss/mixins";

    .custom-dialog {
        .modal-footer > div {
            display: flex;
        }

        &.alert-dialog,
        &.confirm-dialog {
            text-align: center;

            .close-btn {
                display: none;
            }

            .modal-container {
                max-width: 600px;
            }
        }

        &.alert-dialog .modal-body {
            padding-top: $pad-lg;
        }
    }
</style>
